import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { baseUrlAdmin } from '../../store/apiConstants';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';

let selectedBoardClasses;
let filteredSections;
class BranchToClassDD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardId: null,
            classId: [],
            groupId: null,
            branchId: null,
            sectionId: null,
            boards: [],
            classes: [],
            curriculumInfo: {},
            selectedrowData: this.props?.rowData
        };
        this.service = new Service()
    }

    componentDidMount() {
        this.getData();
        // Initialize with saved values if available
        if (this.props.initialValues) {
            const { branchId, boardId, classId } = this.props.initialValues;
            this.setState({
                branchId,
                boardId,
                classId: Array.isArray(classId) ? classId : []
            }, () => {
                if (branchId) {
                    this.onChangeBranch(branchId);
                    // After branch is set, handle board and class
                    setTimeout(() => {
                        if (boardId) {
                            this.onChangeBoard(boardId);
                            // After board is set, handle class
                            setTimeout(() => {
                                if (classId && Array.isArray(classId) && classId.length > 0) {
                                    // Only set classId if we have classes loaded
                                    if (this.state.classes && this.state.classes.length > 0) {
                                        this.onChangeClass(classId);
                                    }
                                }
                            }, 100);
                        }
                    }, 100);
                }
            });
        }
    }

    componentDidUpdate() {


    }

    getData = () => {
        /*         this.props.getBranchesLatest();
                this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');

        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }

        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );

        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchId) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = boards.filter(board =>
            board.assignedBranches.includes(selectedBranchId)
        );

        // If user is admin, return all boards (filtered only by selected branch)
        if (userInfo?.isAdmin === true) {
            // Already filtered by selected branch above
            return this.removeDuplicates(filteredBoards, 'boardId');
        }

        // For teachers, additionally filter by assigned boards
        if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }
        // For non-admin, non-teacher users, filter by assigned boards if available
        else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
            filteredBoards = filteredBoards.filter(board =>
                userInfo?.boardId.includes(board.boardId)
            );
        }

        // Remove duplicate boards by boardId
        return this.removeDuplicates(filteredBoards, 'boardId');
    }

    onChangeBranch = (branchId) => {
        this.setState({
            boards: [], classes: [], sections: [],
        });
        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;

        // Use filtered boards based on selected branch and user role
        let filteredBoards = this.getFilteredBoards(branchId);

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: filteredBoards,
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: [],
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
        },);
    };

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [],
            sections: [],
        });

        // Add null checks and default values
        // First check in state.boards (filtered), then fall back to props.boards
        const selectedBoard = boardId && this.state.boards &&
            this.state.boards.find((board) => board.boardId === boardId);

        if (!selectedBoard) {
            console.warn('Selected board not found');
            this.setState({
                classes: [],
                boardId: '',
                selectedBoardName: '',
                classId: [],
                selectedClass: {},
                branches: [],
                selectedClassName: '',
                sections: [],
                sectionId: '',
                selectedsectionName: '',
            },);
            return;
        }

        // Remove duplicate classes by classId
        const classes = this.removeDuplicates(selectedBoard.classes || [], 'classId');

        this.setState({
            classes: classes,
            boardId,
            selectedBoardName: selectedBoard.boardName || '',
            classId: [],
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            sections: [],
            sectionId: '',
            selectedsectionName: '',
        }, () => this.setDropdownsData());
    };

    onChangeClass = (classId) => {
        // Ensure classId is always an array and filter out null/undefined values
        if (!Array.isArray(classId)) {
            classId = [];
        }

        // Filter out any null, undefined, or 'null' string values
        classId = classId.filter(id => id && id !== 'null' && id !== null && id !== undefined);

        let selectedClass = this.state.classes ?
            this.state.classes.filter((classd) => classId.includes(classd.classId)) :
            [];

        let filteredSections = selectedClass ?
            selectedClass.flatMap((classd) =>
                (classd.sections || []).filter((sec) => sec.branchId == this.state.branchId)
            ) : [];

        this.setState({
            classId: classId,
            selectedClass: selectedClass,
            selectedClassName: selectedClass.map((classd) => classd.className || '').join(', '),
            sections: filteredSections,
            sectionId: '',
            selectedsectionName: '',
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardId,
            classId,
            branchId,
            sectionId,
            selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName
        } = this.state
        let returnData = {
            boardId, classId, branchId, sectionId, selectedBoardName,
            selectedClassName, selectedbranchName, selectedsectionName
        }
        this.props.setValues(returnData)
    }



    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div >
                    <div className='grid '>
                        <div className="col-12">
                            <div className="row-3 my-2">
                                <ClassetDropdown required={true} label={'Branch'} placeholder={'Select Branch'} options={filteredBranchData}
                                    value={this.state.branchId}
                                    // disabled={this.state.selectedrowData?.fmbranchId}
                                    disabled={this.props?.disable >= 1}
                                    onChange={(e) => this.onChangeBranch(e.value)} optionLabel="name"
                                    optionValue="key" />
                            </div>
                            <div className="row-3 my-2">
                                <ClassetDropdown required={true} label={'Board'} placeholder={'Select Board'} options={this.state?.boards} value={this.state.boardId || []} onChange={(e) => this.onChangeBoard(e.value)} optionLabel="boardName"
                                    optionValue="boardId"
                                    disabled={this.props?.disable >= 2}

                                // disabled={this.state.selectedrowData?.fmboardId}
                                />
                            </div>
                            <div className="row-3 my-2">
                                <div className="p-field">
                                    <ClassetMultiSelect
                                        label="Class"
                                        value={this.state.classId}
                                        options={this.state.classes.map((classd) => ({
                                            label: classd.className,
                                            value: classd.classId
                                        }))}
                                        onChange={(e) => this.onChangeClass(e.value)}
                                        disabled={!this.state.boardId}
                                        placeholder="Select Classes"
                                        className="w-100"
                                        display="chip"
                                        maxSelectedLabels={3}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    // boards: state.boardsData.boards,
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToClassDD);